import React, { memo, useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import trans from 'translation';
import { KContainer, KLabel } from 'uikit';

const Payment = () => {
  const data = useMemo(() => {
    return [
      {
        total: 150,
        synced: 50
      },
      {
        total: 150,
        synced: 50
      },
      {
        total: 125,
        synced: 75
      },
      {
        total: 200,
        synced: 75
      },
      {
        total: 100,
        synced: 45
      },
      {
        total: 60,
        synced: 25
      },
      {
        total: 210,
        synced: 100
      },
      {
        total: 170,
        synced: 100
      }
    ];
  }, []);

  const chartData = useMemo(() => {
    return {
      labels: ['Day 1', 'Day 2', 'Day 3', 'Day 4', 'Day 5', 'Day 6', 'Day 7'],
      datasets: [
        {
          label: 'Total',
          data: data.map(item => item.total),
          backgroundColor: '#3995C5',
          barThickness: 20
        },
        {
          label: 'Synced',
          data: data.map(item => item.synced),
          backgroundColor: '#13A89E',
          barThickness: 20
        }
      ]
    };
  }, [data]);

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Total Amount',
        align: 'start' as const,
        font: {
          size: 12
        }
      },
      legend: {
        position: 'bottom' as const,
        labels: {
          boxWidth: 12,
          padding: 20
        },
        display: true
      },
      tooltip: {
        mode: 'index' as const,
        intersect: false
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value: number) => '$' + value.toLocaleString()
        }
      }
    }
  };

  return (
    <KContainer.Card
      height={250}
      marginT={0}
      dp="flex"
      header={{
        title: trans('payment'),
        typo: 'TextMdBold'
      }}
    >
      <KLabel.Text
        color="#FF0000"
        dp="flex"
        alignSelf="flex-end"
        style={{ marginTop: '-2rem' }}
        typo="TextMdMedium"
      >
        {`Today ${new Date().toLocaleDateString()}`}
      </KLabel.Text>
      <KContainer.View height="100%">
        <Bar data={chartData} options={options} />
      </KContainer.View>
    </KContainer.Card>
  );
};

export default memo(Payment);
